import React, { Component } from "react";
import { LoaderPage } from "../../../component/Loader";
import request from "../../../services/requestService";
import {
  deleteNewsLetter,
  getStatusUpload,
  newsLetters
} from "../../../services/apiServices";
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import uploadnewsletter from "../../../assets/uploadNewsletter.svg";
import layerImage from "../../../assets/ImageWithFallback.png";
import delIcon from "../../../assets/IconDel.svg";
import { FILE_FORMAT } from "../../../constant";
import { dateFormat, FormDataForImage } from "../../../helper";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import { UploadMinutesForReviewComponent } from "../../reusableComponent/UploadMinutesForReview/UploadMinutesForReview";
import TooltipCustom from "../../createAgenda/TooltipCustom";
import { toast } from "react-toastify";
import { errorToastStyle, successToastStyle } from "../../../customToast";
import {
  uploadNewsLetterAction,
  uploadStatusAction
} from "../../../actions/common.action";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import NoDataFound from "../../../component/NoDataFound";

class MonthlyNewsLetter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newsLetters: [],
      files: [],
      showConfirmation: false,
      selectedMonth: new Date().getMonth() + 1,
      selectedYear: new Date().getFullYear(),
      loadingOnApi: false,
      timeoutId: null
    };
  }

  componentDidMount() {
    this.callNewsLetter();
  }

  callNewsLetter = async () => {
    this.setState({ loadingOnApi: true });
    const response = await request(newsLetters());
    this.setState({ newsLetters: response.data.data });
    this.setState({ loadingOnApi: false });
  };

  onToggleAttachment = file => {
    const { timeoutId } = this.state;
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay,
        files: file ? [file, ...prevState.files] : prevState.files,
        loadingNewsLetter: false,
        selectedMonth: new Date().getMonth() + 1,
        selectedYear: new Date().getFullYear()
      };
    });
    if (timeoutId) {
      timeoutId && clearTimeout(timeoutId);
    }
  };

  onMonthChange = month => {
    this.setState({ selectedMonth: month });
  };

  onYearChange = year => {
    const { selectedMonth } = this.state;
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    if (year == currentYear) {
      if (Number(selectedMonth) > Number(currentMonth)) {
        this.setState({ selectedMonth: "", selectedYear: Number(year) });
      }
    } else this.setState({ selectedYear: Number(year) });
  };

  delNewsLetter = async () => {
    const { delId, showConfirmation, loadingOnApi } = this.state;
    this.setState({ loadingOnApi: true });
    const payload = {
      fid: delId
    };
    const resp = await request(deleteNewsLetter(payload));
    const { status, data } = resp;

    if (status) {
      this.setState({ loadingOnApi: false });
      toast.success(
        <p className="toast-text-alignment">{data.message}</p>,
        successToastStyle
      );
    } else {
      toast.error(
        <p className="toast-text-alignment">{data && data.message}</p>,
        errorToastStyle
      );
    }
    this.setState({ showConfirmation: !showConfirmation });
    this.callNewsLetter();
  };

  toggleShowConfirmation = () => {
    const { showConfirmation } = this.state;
    this.setState({ showConfirmation: !showConfirmation });
  };

  submitNewsLetter = attachment => {
    const {
      selectedMonth,
      selectedYear,
      loadingNewsLetter = false,
      timeoutId
    } = this.state;
    const { uploadStatus } = this.props;
    if (!attachment.length || !attachment[0].title) {
      toast.error(
        <p className="toast-text-alignment">
          Document and title of file is mandatory
        </p>,
        errorToastStyle
      );
    } else if (
      selectedMonth == null ||
      selectedMonth == "" ||
      selectedYear == null ||
      selectedYear == ""
    ) {
      toast.error(
        <p className="toast-text-alignment">Month and Year is mandatory</p>,
        errorToastStyle
      );
    } else {
      const {
        uploadNewsLetterAction,
        uploadStatusAction,
        onSubmit
      } = this.props;
      const { selectedMonth, selectedYear } = this.state;
      const formData = new FormData();
      formData.append("file", attachment[0]); // raw file
      formData.append("uploadedMonth", selectedMonth);
      formData.append("uploadedYear", selectedYear);
      formData.append("title", attachment[0].title);
      formData.append("uploadedSource", "NEWSLETTER");

      this.setState(
        {
          loadingNewsLetter: true
        },
        async () => {
          const response = await uploadNewsLetterAction(undefined, formData);
          const { data, status, message } = response || {};

          const uploadId = data && data.id;
          if (status && uploadId) {
            const pollStatus = async uploadId => {
              try {
                const resp = await uploadStatusAction(undefined, uploadId);

                const percent =
                  resp && resp.data && resp.data.percentTransferred;
                const failed = resp && resp.data && resp.data.failed;

                if (percent < 100 && !failed) {
                  let timeout = setTimeout(() => pollStatus(uploadId), 3000);
                  this.setState({ timeoutId: timeout });
                } else if (resp.data.failed) {
                  toast.error(
                    <p className="toast-text-alignment">
                      {resp.data.failedReason}
                    </p>,
                    errorToastStyle
                  );
                  this.setState({ loadingNewsLetter: false });
                  timeoutId && clearTimeout(timeoutId);
                } else {
                  if (
                    resp &&
                    resp.data &&
                    resp.data.percentTransferred == 100
                  ) {
                    toast.success(
                      <p className="toast-text-alignment">
                        {"Uploaded Successfully"}
                      </p>,
                      successToastStyle
                    );
                  }
                  this.setState({
                    loadingNewsLetter: false,
                    toggleAttachementDisplay: false
                  });
                  this.callNewsLetter();
                  this.setState({ selectedMonth: null, selectedYear: null });
                }
              } catch (err) {
                this.setState({ loadingNewsLetter: false });
                console.error("Polling failed:", err);
              }
            };

            pollStatus(uploadId);
          } else {
            this.setState({ loadingNewsLetter: false });
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }
        }
      );
    }
  };

  render() {
    const {
      toggleAttachementDisplay,
      newsLetters,
      showConfirmation,
      loadingNewsLetter = false,
      loadingOnApi
    } = this.state;
    return (
      <React.Fragment>
        <LoaderPage loading={loadingOnApi} />
        <div className="documents_container">
          <div className="header-wrapper" style={{ marginTop: "12px" }}>
            <h3 className="header">
              Monthly Newsletter{" "}
              <span
                style={{
                  fontFamily: "mpr",
                  fontSize: "16px",
                  verticalAlign: "middle"
                }}
              >
                ({newsLetters.length})
              </span>
            </h3>
            <OverlayTrigger
              trigger="hover"
              defaultShow={false}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-checking`} className="tooltip-newsletter">
                  Add Newsletter
                </Tooltip>
              }
            >
              <div>
                <Image
                  src={uploadnewsletter}
                  onClick={this.onToggleAttachment}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </OverlayTrigger>
          </div>
          {newsLetters && newsLetters.length == 0 && <NoDataFound />}
          <div style={{ display: "flex", flexWrap: "wrap", gap: "28px" }}>
            {newsLetters.map((val, ind) => {
              const date = new Date(val.uploadedYear, val.uploadedMonth - 1);
              const monthWord = date.toLocaleString("en-US", { month: "long" });
              return (
                <div className="card-newsletter-margin">
                  <h4 className="month-header">
                    {monthWord + " " + val.uploadedYear}
                  </h4>
                  <div className="newsletter-card">
                    <div
                      style={{ display: "flex" }}
                      onClick={() => window.open(val.s3Url, "_blank")}
                    >
                      <Image className="card-layer-image" src={layerImage} />
                    </div>
                    <div style={{ padding: "16px 16px 0px 16px" }}>
                      <span
                        style={{
                          fontFamily: "mpsb",
                          fontSize: "16px"
                        }}
                      >
                        {val.title}
                      </span>
                      <div className="bottom-newsletter">
                        <span style={{ fontSize: "12px", color: "#525252" }}>
                          Uploaded on{" "}
                          <span style={{ color: "#000" }}>
                            {dateFormat(val.uploadedOn)}
                          </span>
                        </span>
                        <Image
                          src={delIcon}
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            this.setState({
                              showConfirmation: true,
                              delId: val.id
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {toggleAttachementDisplay ? (
          <UploadMinutesForReviewComponent
            displayModal={toggleAttachementDisplay}
            onCloseModal={this.onToggleAttachment}
            fileFormats={FILE_FORMAT}
            newsLetter={true}
            onMonthChange={this.onMonthChange}
            selectedMonth={this.state.selectedMonth}
            onYearChange={this.onYearChange}
            selectedYear={this.state.selectedYear}
            onSubmitNewsLetter={this.submitNewsLetter}
            loadingNewsLetter={this.state.loadingNewsLetter}
          />
        ) : null}
        {showConfirmation ? (
          <ConfirmationComponent
            show={showConfirmation}
            isLoading={false}
            modalClass={"confirmation-modal newsletter-delete"}
            saveHandler={this.delNewsLetter}
            closeHandler={this.toggleShowConfirmation}
            content={"Are you sure you want to delete this newsletter?"}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

// export default MonthlyNewsLetter;

function mapStateToProps(state) {
  return {
    uploadStatus: state.commonReducer.uploadStatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      uploadNewsLetterAction,
      uploadStatusAction
    },
    dispatch
  );
}

const MonthlyNewsLetterComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(MonthlyNewsLetter);
export { MonthlyNewsLetterComponent };
